import { render, staticRenderFns } from "./transfer-report-form.vue?vue&type=template&id=e4bcf808&scoped=true"
import script from "./transfer-report-form.vue?vue&type=script&lang=js"
export * from "./transfer-report-form.vue?vue&type=script&lang=js"
import style0 from "./transfer-report-form.vue?vue&type=style&index=0&id=e4bcf808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bcf808",
  null
  
)

export default component.exports